module.exports = __webpack_public_path__ + "public/Icons/question.svg?c102e2d0";